module.exports = __webpack_public_path__ + "school/img/chuanHistoryBg.0608168b.jpg";